import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    skillItem: {
        marginBottom: '15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    skillImage: {
        padding: '10px',
        height: '80px',
        width: '80px',
        borderRadius: '10px',
        marginTop: '15px',
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& img': {
            height: '50px',
            width: '50px',
        },
        '&.color1': {
            backgroundColor: '#8BC795',
        },
        '&.color2': {
            backgroundColor: '#51C5A4',
        },
        '&.color3': {
            backgroundColor: '#17C3B2',
        },
        '&.color4': {
            backgroundColor: '#227C9D',
        },
        '&.color5': {
            backgroundColor: '#1C6782',
        },
        '&.color6': {
            backgroundColor: '#C5C986',
        },
        '&.color7': {
            backgroundColor: '#FFCB77',
        },
        '&.color8': {
            backgroundColor: '#FFB476',
        },
        '&.color9': {
            backgroundColor: '#FF9C75',
        },
        '&.color10': {
            backgroundColor: '#FE6D73',
        }
    },
})

function SkillItem(prop) {

    const classes = useStyles()

    return (
        <div className={classes.skillItem}>
            <div className={classes.skillImage + " " + prop.color}>
                <img src={prop.image} alt="" />
            </div>
            <h5>{prop.name}</h5>
        </div>
    )
}

export default SkillItem
